<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div class="grid grid-cols-12 gap-3 pt-5 container">
            <div class="col-span-12 md:col-span-4 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                    {{ $t('product.choose') }}
                </div>
                <v-select
                    :options="products"
                    label="name"
                    v-model="modelForm.productInWarehouse"
                >
                    <template #no-options="{}">
                        {{ $t("selectError") }}
                    </template>
                </v-select>
            </div>

            <div class="col-span-12 md:col-span-4 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                    {{ $t('warehouse.choose') }}
                </div>
                <v-select
                    class="col-sm-12"
                    :options="warehouses"
                    label="name"
                    v-model="modelForm.newWarehouse"
                >
                    <template #no-options="{}">
                        {{ $t("selectError") }}
                    </template>
                </v-select>
            </div>

            <div class="col-span-12 md:col-span-2 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                    {{ $t('amount') }}
                </div>
                <b-form-input
                    class="border-gray-300 h-11 focus:ring-0"
                    type="number"
                    v-model.number="modelForm.amount"
                    :max="modelForm.productInWarehouse ? modelForm.productInWarehouse.amount : undefined"
                    min="1"
                />
            </div>

            <div class="col-span-12 md:col-span-2 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                    {{ $t('unitOfMeasure.short') }}
                </div>
                <div class="card h-11 flex justify-center items-center">
                    {{ modelForm.productInWarehouse ? showUnitOfMeasure(modelForm.productInWarehouse.product.unitOfMeasure) : '' }}
                </div>

            </div>
        </div>

        <div class="grid grid-cols-12 container mt-4 pb-4">
            <div class="col-span-3">
                <ButtonTag :do-action="add" :is-w100="true" :is-tw-main-btn="true"
                           :is-disabled="hasErrors || !modelForm.productInWarehouse || !modelForm.newWarehouse">
                    <TextTag :xs-display="false" :sm-display="true">
                        {{ $t('add') }}
                    </TextTag>
                    <TextTag :sm-display="false">
                        {{ $t('add') }}
                    </TextTag>
                </ButtonTag>
            </div>

            <div class="col-start-10 col-span-3">
                <SubmitRow
                    sm-size="12"
                    md-size="12"
                    :is-disabled="warehouseChangeDtos.length === 0"
                    :is-loading="isLoading"
                    :do-action="changeWarehouse"
                    text="move"
                />
            </div>
        </div>

        <div v-if="warehouseChangeDtos.length > 0" class="mt-4">
            <TableTag
                :data="warehouseChangeDtos"
                :headers="['#', 'product.title', 'amount', 'warehouse.title', 'actions']"
                :body-properties="['order', 'productName', 'amount', 'warehouseName', 'actions', ]"
            >
                <template v-slot:actions="{rowIndex}">
                    <img src="/images/Union.png" alt="" @click="remove(rowIndex)" class="h-6 cursor-pointer">
                </template>
            </TableTag>
            <div class="flex justify-center bg-lightGray py-2">
                <div class="font-bold">{{ $t('total') }}:</div>
                <div class="pl-2"> {{ $t('productsInWarehouse.changingProductsAmount', {amount: warehouseChangeDtos.length}) }}</div>
            </div>
        </div>
    </Row>
</template>

<script>
import ButtonTag from "../../components/html/ButtonTag";
import TextTag from "../../components/html/TextTag";
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import SubmitRow from "../../components/SubmitRow";
import Row from "../../components/html/Row";
import Modal from "@/components/html/Modal";
import '../../style/vue-select.css';
import vSelect from 'vue-select'
import CurrencyFormatMixin from "../../mixin/currencyFormatMixin";
import TableTag from "../../components/html/TableTag";

export default {
    name: "ProductPurchasesPurchase",
    components: {
        Row,
        SubmitRow,
        Modal,
        vSelect,
        ButtonTag,
        TextTag,
        TableTag,
    },
    mixins: [validatorMixin, CurrencyFormatMixin],
    data() {
        return {
            products: [],
            modalText: '',
            isLoading: false,
            errors: {
                productInWarehouse: null,
                newWarehouse: null,
                amount: null,
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'move'},
            ],
            modelForm: {
                productInWarehouse: null,
                newWarehouse: null,
                amount: 1,
            },
            warehouseChangeDtos: [],
        }
    },
    computed: {
        ...mapGetters(['getWarehouses', 'getProductsInWarehouses', 'getProducts', 'getCurrencies']),
        warehouses() {
            if (this.modelForm.productInWarehouse) {
                return this.getWarehouses.filter((w) => w.id !== this.modelForm.productInWarehouse.warehouse.id)
            }

            return this.getWarehouses
        }
    },
    methods: {
        ...mapActions(['fetchProductsInWarehouses', 'fetchWarehousesSearch', 'changeWarehouseProducts', 'setBreadcrumbItems']),
        add() {
            this.products.map((product) => {
                if (product === this.modelForm.productInWarehouse) {
                    product.amount -= this.modelForm.amount
                }
            })

            this.warehouseChangeDtos.push(
                {
                    order: this.warehouseChangeDtos.length + 1,
                    warehouseName: this.modelForm.newWarehouse.name,
                    productName: this.modelForm.productInWarehouse.name,
                    newWarehouse: this.modelForm.newWarehouse['@id'],
                    productInWarehouse: this.modelForm.productInWarehouse['@id'],
                    amount: this.modelForm.amount
                }
            )

            this.modelForm.amount = 1
            this.modelForm.newWarehouse = null
            this.modelForm.productInWarehouse = null

            this.afterFetchProductsInWarehouses(this.products)
        },
        remove(rowIndex) {
            this.products.map((obj) => {
                if (obj === this.warehouseChangeDtos[rowIndex].productInWarehouse) {
                    obj.amount += this.warehouseChangeDtos[rowIndex].amount
                }
            })

            this.warehouseChangeDtos.splice(rowIndex, 1)

            this.afterFetchProductsInWarehouses(this.products)
        },
        afterFetchProductsInWarehouses(models) {
            for (let key in models) {
                let item = models[key]
                item.name = item.product.name + ' (' + item.amount + ' ' + this.showUnitOfMeasure(item.product.unitOfMeasure) + ', ' + item.warehouse.name + ')'
            }
        },
        changeWarehouse() {
            this.$root.showOverlay = true
            this.isLoading = true

            this.changeWarehouseProducts({warehouseChangeDtos: this.warehouseChangeDtos})
                .then(() => {
                    this.$i18nHelper.toUrl('products-in-warehouses')
                })
                .catch((reason) => {
                    this.isLoading = false
                    this.modalText = reason
                    this.$root.showOverlay = false
                })
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        window.scrollTo(0, 0)
        this.$root.showOverlay = true

        this.fetchProductsInWarehouses(null)
            .then(() => {
                this.products = this.getProductsInWarehouses
                this.afterFetchProductsInWarehouses(this.products)
            })
        this.fetchWarehousesSearch()
            .then(() => {
                this.$root.showOverlay = false
            })
    },
}
</script>
